import React from 'react';
import { motion } from 'framer-motion';
import ContactAmbientBg from '../components/ContactAmbientBg';
import ContactForm from '../components/ContactForm';
import GlobalPresence from '../components/GlobalPresence';
import FormulationFinder from '../components/FormulationFinder';
import { fadeUp, staggerContainer } from '../motion/variants';

const INFO_ROWS = [
  { lbl: 'Website', val: 'www.auraluxmaterials.com' },
  { lbl: 'General Inquiries', val: 'info@auraluxmaterials.com' },
  { lbl: 'Technical Support', val: 'Tech@auraluxmaterials.com' },
  { lbl: 'Response Time', val: 'Within 24 business hours' },
];

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="sec sec-process-wrap contact-ht contact-ht--light"
      data-palette="white"
    >
      <ContactAmbientBg />
      <div className="sec-process-content contact-ht__inner">
        <motion.div
          className="contact-ht__hdr"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="kicker k-gold" variants={fadeUp}>
            Get in Touch
          </motion.div>
          <motion.h2 className="title lt contact-ht__title" variants={fadeUp}>
            Contact our team
          </motion.h2>
          <motion.p className="contact-ht__lead" variants={fadeUp}>
            Share your application details and we&apos;ll connect you with the right formulation specialist.
          </motion.p>
        </motion.div>

        <div className="contact-ht__grid">
          <motion.div
            className="contact-ht__info"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="contact-ht__info-panel">
              {INFO_ROWS.map((row) => (
                <div key={row.lbl} className="contact-ht__row">
                  <div className="contact-ht__lbl">{row.lbl}</div>
                  <div className="contact-ht__val">{row.val}</div>
                </div>
              ))}
            </div>
            <GlobalPresence />
          </motion.div>

          <motion.div
            className="contact-ht__form-wrap"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="contact-ht__form-panel">
              <ContactForm />
              <div className="contact-ht__form-extra">
                <FormulationFinder triggerClassName="contact-ht__finder-link" triggerLabel="Open Formulation Finder" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
